<template>
    <img class="multi-img" :src="src" :alt="name" @click="onClick" />
</template>

<script>
export default {
    name: 'multi-img',
    props: {
        directory: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        src() {
            const dpr = window.devicePixelRatio
            let name = this.name
            const DOUBLE = '@2x'
            const THREE = '@3x'
            name += dpr >= 3 ? THREE : DOUBLE
            return require('@/assets/images/' + this.directory + '/' + name + '.png')
        },
    },
    methods: {
        onClick(e) {
            this.$emit('click', e)
        },
    },
}
</script>
